export default __webpack_public_path__ + "static/media/1718.721abe32.png";